import React from "react";
//import * as yup from "yup";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import LawSection from "./LawSection";
import LawType from "./LawType";
import Org from "./Org";
import OrgType from "./OrgType";
import VoteType from "./VoteType";
import { VoteDateContextProvider } from "contexts/VoteDate";

import customTabsStyles from "assets/jss/material-dashboard-pro-react/components/customTabsStyleForECTPL";

const styles = {
  textCenter: {
    textAlign: "center"
  },
  //tabRoot: { backgroundColor: "#0a6" },
  span: {
    backgroundColor: "#aa0",
    fontSize: "22px"
  }
};

const useStyles = makeStyles(styles);

const OptHandler = props => {
  const classes = useStyles();

/*   const addOptSchema = yup.object().shape({
    provinceId: yup.string().required("This field is required."),
    amphurId: yup.string().required("This field is required.")
  }); */

  //   const addOptForm = useForm({
  //     validationSchema: addOptSchema
  //   });

  return (
    <VoteDateContextProvider>
      <div className={classes.tabcustom}>
        <form>
          <CustomTabs
            styles={customTabsStyles}
            headerColor="info"
            tabs={[
              {
                tabName: "ประเภทหน่วยงาน",
                tabContent: <OrgType />
              },
              {
                tabName: "หน่วยงาน",
                tabContent: <Org />
              },
              {
                tabName: "กฏหมาย",
                tabContent: <LawType />
              },
              {
                tabName: "มาตรา",
                tabContent: <LawSection />
              },
              {
                tabName: "ประเภทการเลือกตั้ง",
                tabContent: <VoteType />
              }
            ]}
          />
        </form>
      </div>
    </VoteDateContextProvider>
  );
};

export default OptHandler;
